import {
  useCreateGuestScenarioMutation,
  useCreateGuestScenarioPageMutation,
  useCreateScenarioMutation,
  useCreateScenarioPageMutation,
  useCreateScenarioPartialMutation,
  useCreateGuestScenarioPartialMutation,
  usePublishScenarioMutation,
  usePublishGuestScenarioMutation,
  useCreateBatchScenarioPartialsMutation,
  useCreateGuestBatchScenarioPartialsMutation,
} from '@app-velocity/modules/scenarios';

import { useConfigureScenarioContext } from '../context/useConfigureScenarioContext';

export const useConfigureScenarioMutations = (
  abortController: AbortController
) => {
  const { mode, workspaceId } = useConfigureScenarioContext();

  const createScenarioAsAuth = useCreateScenarioMutation(
    workspaceId,
    abortController.signal
  );
  const createScenarioAsGuest = useCreateGuestScenarioMutation(
    workspaceId,
    abortController.signal
  );

  const createPageAsAuth = useCreateScenarioPageMutation(
    workspaceId,
    abortController.signal
  );
  const createPageAsGuest = useCreateGuestScenarioPageMutation(
    workspaceId,
    abortController.signal
  );

  const createPartialAsAuth = useCreateScenarioPartialMutation(
    workspaceId,
    abortController.signal
  );
  const createPartialAsGuest = useCreateGuestScenarioPartialMutation(
    workspaceId,
    abortController.signal
  );

  const createBatchPartialsAsAuth = useCreateBatchScenarioPartialsMutation(
    workspaceId,
    abortController.signal
  );
  const createBatchPartialsAsGuest =
    useCreateGuestBatchScenarioPartialsMutation(
      workspaceId,
      abortController.signal
    );

  const publishScenarioAsAuth = usePublishScenarioMutation(
    workspaceId,
    abortController.signal
  );
  const publishScenarioAsGuest = usePublishGuestScenarioMutation(
    workspaceId,
    abortController.signal
  );

  if (mode === 'authorized') {
    return {
      abortController,
      createScenarioMutation: createScenarioAsAuth,
      createPageMutation: createPageAsAuth,
      createPartialMutation: createPartialAsAuth,
      createBatchPartialsMutation: createBatchPartialsAsAuth,
      publishScenarioMutation: publishScenarioAsAuth,
    };
  }

  return {
    abortController,
    createScenarioMutation: createScenarioAsGuest,
    createPageMutation: createPageAsGuest,
    createPartialMutation: createPartialAsGuest,
    createBatchPartialsMutation: createBatchPartialsAsGuest,
    publishScenarioMutation: publishScenarioAsGuest,
  };
};
